const ACTIVATING_CLASS = "activating";
const DEACTIVATING_CLASS = "deactivating";

const ACTIVATE_CNTENT_TIME = 400;
const GO_TO_INDEX_TIME = 400;
const DEACTIVATE_CNTENT_TIME = 200;

function unify(e) {
    return e.changedTouches ? e.changedTouches[0] : e
}

/**
 * Cover Slider class to object and add listeners to 
 * multiple cover sliders
 */
export default class CoverSlider {

    /**
     * constructor for the class
     * @param {object} $element jquery element
     * @return {CoverVideo} this class
     */
    constructor($element) {
        //asign eelement
        this.el = $element;
        //assign next trigger
        this.nextTriggerItem = $element.find('.cover-slider--rightnav');
        //assign viewport
        this.viewPort = $element.find('.cover-slider--viewport');
        //assign timeline
        this.timeLine = $element.find('.cover-slider--timeline');
        //assign previous trigger
        this.previousTriggerItem = $element.find('.cover-slider--leftnav');
        //assign dotnav items
        this.dotNavItems = $element.find('[data-slidenav]');
        //assign current slide index
        this.currentSlideIndex = parseInt($element.attr('data-activeslide'), 10);
        //assign current index nav
        this.currentNavContent = $element.find('.cover-slider--current-index');
        //max available slides
        this.maxSlides = $element
                            .find('.cover-slider--slide')
                            .filter('[data-slideavailable="true"]')
                            .length;

        //for UX set up
        this.actionQueue = [];

        //attach listeners to triggers
        this.attachListeners();

        //attach draggables
        this.locked = false;
        this.x0 = null;
        this.dx = 0;
        this.f = 0;
        this.w = this.viewPort.width();
        this.attachDraggables();


        //initial setup
        this.assignActiveCurrentSlideInfo();
    }

    attachDraggables() {
        const lock = this.lock.bind(this);
        const drag = this.drag.bind(this);
        const move = this.move.bind(this);


        this.timeLine[0].addEventListener('mousedown', lock, false);
        this.timeLine[0].addEventListener('touchstart', lock, false);

        this.timeLine[0].addEventListener('mousemove', drag, false);
        this.timeLine[0].addEventListener('touchmove', drag, false);

        this.timeLine[0].addEventListener('mouseup', move, false);
        this.timeLine[0].addEventListener('touchend', move, false);

        this.timeLine[0].addEventListener('touchleave', move, false);
        this.timeLine[0].addEventListener('touchcancel', move, false);
        this.timeLine[0].addEventListener('mouseleave', move, false);
    }

    lock(e) {
        e.preventDefault();
        this.x0 = unify(e).clientX;
        this.w = this.viewPort.width();
        this.locked = true
        this.timeLine.addClass('lock-animation');
        this.el.addClass(DEACTIVATING_CLASS);
        this.el.find('.cover-slider--slide').removeClass('active');
    }

    move(e) {
        e.preventDefault();
        if (this.locked) {
            this.timeLine.removeClass('lock-animation');

            this.dx = unify(e).clientX - this.x0;
            //directional left or right
            const direction = Math.sign(this.dx);
            //get the amount of given direction related to the width of the container
            const f = Number(direction * this.dx / this.w)

            // move to previous slide
            if (f > 0.3 && direction > 0) {
                this.currentSlideIndex -= 1;
            // move to next slide
            } else if (f >0.3 && direction < 0) {
                this.currentSlideIndex += 1;
            }
            //move to correct slide and activate
            this.normalizeSlideIndex();
            this.el.attr('data-activeslide', this.currentSlideIndex);
            this.setSlideIndex();
            this.assignActiveCurrentSlideInfo();
            
            setTimeout( () => {
                this.el.removeClass(DEACTIVATING_CLASS);
            }, GO_TO_INDEX_TIME);

            this.x0 = null;
            this.locked = false;
            this.timeLine[0].setAttribute('style','');
        }
    }

    normalizeSlideIndex() {
        if (this.currentSlideIndex === this.maxSlides) {
            this.currentSlideIndex = this.maxSlides - 1;
        } else if (this.currentSlideIndex < 0) {
            this.currentSlideIndex = 0;
        }
    }

    drag(e) {
        e.preventDefault();
          
        if (this.locked) {
            this.dx = unify(e).clientX - this.x0;
            const f = Number(this.dx / this.w).toFixed(2);
            const leftAtSlide = -this.currentSlideIndex*100;
            const leftMove = leftAtSlide+(f*100);
            this.timeLine[0].setAttribute('style',`left: ${leftMove}%`);
        }
    }

    setSlideIndex() {
        const $navIndexEl = this.el.find('.cover-slider--current-index');
        if ($navIndexEl) {
            const prettyIndex = ('0' + (this.currentSlideIndex+1)).slice(-2);
            $navIndexEl.html(prettyIndex)
        }
    }

    /**
     * Accessory getter for current slide element
     * @return {object} jquery element
     */
    currentSlide() {
        return jQuery(this.el.find('.cover-slider--slide').get(this.currentSlideIndex));
    }

    /**
     * Accessory getter for current slide description element
     * @return {object} jquery element
     */
    currentSlideDescription() {
        return jQuery(this.el.find('.cover-slider--slide-content--description').get(this.currentSlideIndex));
    }

    /**
     * run initial setup
     * @return {null} nothing
     */
    assignActiveCurrentSlideInfo() {
        //add active to current slide
        this.currentSlide().addClass('active');
        //add active to current slide description
        this.currentSlideDescription().addClass('active');
    }

    /**
     * Attach listeners
     * @return {null} nothing
     */
    attachListeners() {
        this.nextTriggerItem.on('click', this.nextItem.bind(this));
        this.previousTriggerItem.on('click', this.previousItem.bind(this));
        this.dotNavItems.on('click', this.goToItem.bind(this));
    }

    /**
     * listener for next item trigger
     * @param {object} event dom event
     * @return {null} nothing
     */
    nextItem() {
        //not currently in mid transition
        if (this.availableToChangeSlide()) {
            this.currentSlideIndex += 1;
            //if at end of slides to go beginning
            this.normalizeSlideIndex();


            this.deactivateContent()
                .goToIndex()
                .activateContent()
                .run();
        }
    }

    /**
     * listener for previous item trigger
     * @param {object} event dom event
     * @return {null} nothing
     */
    previousItem() {
       //not currently in mid transition
       if (this.availableToChangeSlide()) {
            this.currentSlideIndex -= 1;
            //if at beginning slide, go to end of slides
            this.normalizeSlideIndex();

            this.deactivateContent()
                .goToIndex()
                .activateContent()
                .run();
        }
    }

    /**
     * listener for dot nav item trigger
     * @param {object} event dom event
     * @return {null} nothing
     */
    goToItem(event) {
        const item = event.target;
        const $selectedItem = jQuery(item);

        //not currently in mid transition
        if (this.availableToChangeSlide()) {
            const triggerIndex = parseInt($selectedItem.attr('data-slidenav'), 10);
            this.currentSlideIndex = triggerIndex;
    
            this.deactivateContent()
                .goToIndex()
                .activateContent()
                .run();
        }
    }

    /**
     * checks to see if slider is available to change slide
     * @return {boolean} slider available or not
     */
    availableToChangeSlide() {
        return this.el.attr('data-activeslide') === `${this.currentSlideIndex}` && !this.el.hasClass('deactivating');
    }

    /**
     * deactivate content made for method chaining
     * @return {CoverSlider} reference to this object
     */
    deactivateContent() {
        //add deactivation to action queue
        this.actionQueue.push( {
            duration: DEACTIVATE_CNTENT_TIME,
            runAction: () => {
                this.el.addClass(DEACTIVATING_CLASS);
                //remove current active class for slide data
                this.el.find('.cover-slider--slide').removeClass('active');
                this.el.find('.cover-slider--slide-content--description').removeClass('active');
        
            }
        });
        return this;
    }

    /**
     * go to index content made for method chaining
     * @return {CoverVideo} reference to this object
     */
    goToIndex() {
        //remove activating, add activated
        this.actionQueue.push( {
            duration: GO_TO_INDEX_TIME,
            runAction: () => {
                this.el.removeClass(DEACTIVATING_CLASS);
                this.el.addClass(ACTIVATING_CLASS);
                this.el.attr('data-activeslide', this.currentSlideIndex);
                this.setSlideIndex();
            }
        });
        return this;
    }

    /**
     * activate content made for method chaining
     * @return {CoverVideo} reference to this object
     */
    activateContent() {
        //remove activating
        this.actionQueue.push( {
            duration: ACTIVATE_CNTENT_TIME,
            runAction: () => {
                this.el.removeClass(ACTIVATING_CLASS);
                this.assignActiveCurrentSlideInfo();
            }
        });
        return this;
    }

    /**
     * primary method to run through the action queue
     * @return {null} nothing
     */
    run() {
        //execute the action queue if exists and assign delay
        if (this.actionQueue.length > 0) {
            var thisAction = this.actionQueue.shift();
            thisAction.runAction();

            //set up next action
            setTimeout(() => {
                this.run();
            }, thisAction.duration)
        }
    }
}